module.exports = __webpack_public_path__ + "media/assets/images/nosco_landing/efficiente-7e105685e89fb0209c29cb3be088a3f4.svg";